import type { AbnormalReport, Template } from '../api/types';
import { Modal } from './Modal';

function label(template: Template, key: string): string {
  for (const s of template.sections) {
    const f = s.fields.find((x) => x.key === key);
    if (f) return `${s.label} · ${f.label}`;
  }
  return key;
}

/** O6 — shown when one or more values fall outside the configured range. Never blocks. */
export default function AbnormalReview(props: {
  report: AbnormalReport;
  template: Template;
  onEdit: () => void;
  onConfirm: () => void;
  busy?: boolean;
}) {
  const { report, template, onEdit, onConfirm, busy } = props;
  const critical = report.status === 'critical';
  return (
    <Modal
      title={critical ? '⛔ Check these readings' : '⚠ Check these readings'}
      onClose={() => !busy && onEdit()}
      footer={<>
        <button className="secondary" onClick={onEdit} disabled={busy}>Edit reading</button>
        <button onClick={onConfirm} disabled={busy}>{busy ? 'Saving…' : 'Confirm correct'}</button>
      </>}
    >
      <p className="muted">
        The following {report.fields.length === 1 ? 'value looks' : 'values look'} unusual.
        Confirm they are correct, or go back and edit.
      </p>
      {report.fields.map((f) => (
        <div key={f.field} className="card" style={{ background: 'var(--card-2)' }}>
          <strong>{label(template, f.field)}</strong>
          <div className="row">
            <span className="k">Entered</span>
            <span className={critical ? 'error' : ''}>{f.value}</span>
          </div>
          {(f.normalMin !== null || f.normalMax !== null) && (
            <div className="row">
              <span className="k">Normal range</span>
              <span>{f.normalMin ?? '–'} to {f.normalMax ?? '–'}</span>
            </div>
          )}
          <span className={`chip ${f.severity === 'critical' ? 'bad' : 'warn'}`}>{f.severity}</span>
        </div>
      ))}
    </Modal>
  );
}
